import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import {
  getMappedNationalities,
  getMappedCountries,
} from "@rentiohq/shared-frontend/dist/utils/location/location.utils";
import {
  ERentioFormField,
  IUiSchema,
} from "@rentiohq/web-shared-next/dist/utils/types/form";
import { EField } from "./schema.profileExtra.types";

export const uiSchema = (): IUiSchema => {
  return {
    stepTitle: getLocalizedText("task.information.section_header"),
    heading: getLocalizedText("task.information.section_header"),
    fields: [
      {
        fieldKey: EField.DateOfBirth,
        uiComponent: ERentioFormField.Date,
        title: getLocalizedText("system.date_of_birth"),
        optional: true,
        componentProps: {
          autoFocus: true,
          disablePast: false,
          placeholder: getLocalizedText("system.date_of_birth"),
        },
      },
      {
        fieldKey: "heading",
        uiComponent: ERentioFormField.Heading,
        componentProps: {
          title: getLocalizedText("system.place_of_birth"),
        },
      },
      {
        fieldKey: EField.PlaceOfBirth,
        uiComponent: ERentioFormField.TextField,
        title: getLocalizedText("address.city"),
        optional: true,
        componentProps: {
          placeholder: getLocalizedText("address.city"),
        },
      },
      {
        fieldKey: EField.countryOfBirth,
        uiComponent: ERentioFormField.Select,
        title: getLocalizedText("address.country"),
        optional: true,
        componentProps: {
          placeholder: getLocalizedText("address.country"),
          options: getMappedCountries(),
        },
      },
      {
        fieldKey: EField.Nationality,
        title: getLocalizedText("system.nationality"),
        uiComponent: ERentioFormField.Select,
        optional: true,
        componentProps: {
          placeholder: getLocalizedText("system.nationality"),
          options: getMappedNationalities(),
        },
      },
    ],
  };
};
